export default __webpack_public_path__ + "static/media/invest-fund-icon.382a992c.svg";